// adapter 中有一个 return null, 非常影响页面的首次加载速度, 尽可能把层级下降

"use client"

import Adapter from "../Adapter";
import Header from "./header";

const HeaderServer = ({
  announcementsData 
}) => {
  return (
    <Adapter showLoading={true}>
      <Header announcementsData={announcementsData} />
    </Adapter>
  )
}

export default HeaderServer
